/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  float8: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "artifacts_by_project_v1" */
export type Artifacts_By_Project_V1 = {
  __typename?: 'artifacts_by_project_v1';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "artifacts_by_project_v1" */
export type Artifacts_By_Project_V1_Aggregate = {
  __typename?: 'artifacts_by_project_v1_aggregate';
  aggregate?: Maybe<Artifacts_By_Project_V1_Aggregate_Fields>;
  nodes: Array<Artifacts_By_Project_V1>;
};

/** aggregate fields of "artifacts_by_project_v1" */
export type Artifacts_By_Project_V1_Aggregate_Fields = {
  __typename?: 'artifacts_by_project_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Artifacts_By_Project_V1_Max_Fields>;
  min?: Maybe<Artifacts_By_Project_V1_Min_Fields>;
};


/** aggregate fields of "artifacts_by_project_v1" */
export type Artifacts_By_Project_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Artifacts_By_Project_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "artifacts_by_project_v1". All fields are combined with a logical 'AND'. */
export type Artifacts_By_Project_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Artifacts_By_Project_V1_Bool_Exp>>;
  _not?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Artifacts_By_Project_V1_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  artifact_name?: InputMaybe<String_Comparison_Exp>;
  artifact_namespace?: InputMaybe<String_Comparison_Exp>;
  artifact_source?: InputMaybe<String_Comparison_Exp>;
  artifact_source_id?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Artifacts_By_Project_V1_Max_Fields = {
  __typename?: 'artifacts_by_project_v1_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Artifacts_By_Project_V1_Min_Fields = {
  __typename?: 'artifacts_by_project_v1_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "artifacts_by_project_v1". */
export type Artifacts_By_Project_V1_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  artifact_name?: InputMaybe<Order_By>;
  artifact_namespace?: InputMaybe<Order_By>;
  artifact_source?: InputMaybe<Order_By>;
  artifact_source_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
};

/** select columns of table "artifacts_by_project_v1" */
export enum Artifacts_By_Project_V1_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  ArtifactName = 'artifact_name',
  /** column name */
  ArtifactNamespace = 'artifact_namespace',
  /** column name */
  ArtifactSource = 'artifact_source',
  /** column name */
  ArtifactSourceId = 'artifact_source_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source'
}

/** Streaming cursor of the table "artifacts_by_project_v1" */
export type Artifacts_By_Project_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Artifacts_By_Project_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Artifacts_By_Project_V1_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  artifact_name?: InputMaybe<Scalars['String']['input']>;
  artifact_namespace?: InputMaybe<Scalars['String']['input']>;
  artifact_source?: InputMaybe<Scalars['String']['input']>;
  artifact_source_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "artifacts_v1" */
export type Artifacts_V1 = {
  __typename?: 'artifacts_v1';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "artifacts_v1" */
export type Artifacts_V1_Aggregate = {
  __typename?: 'artifacts_v1_aggregate';
  aggregate?: Maybe<Artifacts_V1_Aggregate_Fields>;
  nodes: Array<Artifacts_V1>;
};

/** aggregate fields of "artifacts_v1" */
export type Artifacts_V1_Aggregate_Fields = {
  __typename?: 'artifacts_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Artifacts_V1_Max_Fields>;
  min?: Maybe<Artifacts_V1_Min_Fields>;
};


/** aggregate fields of "artifacts_v1" */
export type Artifacts_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Artifacts_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "artifacts_v1". All fields are combined with a logical 'AND'. */
export type Artifacts_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Artifacts_V1_Bool_Exp>>;
  _not?: InputMaybe<Artifacts_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Artifacts_V1_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  artifact_name?: InputMaybe<String_Comparison_Exp>;
  artifact_namespace?: InputMaybe<String_Comparison_Exp>;
  artifact_source?: InputMaybe<String_Comparison_Exp>;
  artifact_source_id?: InputMaybe<String_Comparison_Exp>;
  artifact_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Artifacts_V1_Max_Fields = {
  __typename?: 'artifacts_v1_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Artifacts_V1_Min_Fields = {
  __typename?: 'artifacts_v1_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "artifacts_v1". */
export type Artifacts_V1_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  artifact_name?: InputMaybe<Order_By>;
  artifact_namespace?: InputMaybe<Order_By>;
  artifact_source?: InputMaybe<Order_By>;
  artifact_source_id?: InputMaybe<Order_By>;
  artifact_url?: InputMaybe<Order_By>;
};

/** select columns of table "artifacts_v1" */
export enum Artifacts_V1_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  ArtifactName = 'artifact_name',
  /** column name */
  ArtifactNamespace = 'artifact_namespace',
  /** column name */
  ArtifactSource = 'artifact_source',
  /** column name */
  ArtifactSourceId = 'artifact_source_id',
  /** column name */
  ArtifactUrl = 'artifact_url'
}

/** Streaming cursor of the table "artifacts_v1" */
export type Artifacts_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Artifacts_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Artifacts_V1_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  artifact_name?: InputMaybe<Scalars['String']['input']>;
  artifact_namespace?: InputMaybe<Scalars['String']['input']>;
  artifact_source?: InputMaybe<Scalars['String']['input']>;
  artifact_source_id?: InputMaybe<Scalars['String']['input']>;
  artifact_url?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "code_metrics_by_project_v1" */
export type Code_Metrics_By_Project_V1 = {
  __typename?: 'code_metrics_by_project_v1';
  active_developer_count_6_months?: Maybe<Scalars['float8']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  commit_count_6_months?: Maybe<Scalars['float8']['output']>;
  contributor_count?: Maybe<Scalars['float8']['output']>;
  contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  fork_count?: Maybe<Scalars['bigint']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  repository_count?: Maybe<Scalars['bigint']['output']>;
  star_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "code_metrics_by_project_v1" */
export type Code_Metrics_By_Project_V1_Aggregate = {
  __typename?: 'code_metrics_by_project_v1_aggregate';
  aggregate?: Maybe<Code_Metrics_By_Project_V1_Aggregate_Fields>;
  nodes: Array<Code_Metrics_By_Project_V1>;
};

/** aggregate fields of "code_metrics_by_project_v1" */
export type Code_Metrics_By_Project_V1_Aggregate_Fields = {
  __typename?: 'code_metrics_by_project_v1_aggregate_fields';
  avg?: Maybe<Code_Metrics_By_Project_V1_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Code_Metrics_By_Project_V1_Max_Fields>;
  min?: Maybe<Code_Metrics_By_Project_V1_Min_Fields>;
  stddev?: Maybe<Code_Metrics_By_Project_V1_Stddev_Fields>;
  stddev_pop?: Maybe<Code_Metrics_By_Project_V1_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Code_Metrics_By_Project_V1_Stddev_Samp_Fields>;
  sum?: Maybe<Code_Metrics_By_Project_V1_Sum_Fields>;
  var_pop?: Maybe<Code_Metrics_By_Project_V1_Var_Pop_Fields>;
  var_samp?: Maybe<Code_Metrics_By_Project_V1_Var_Samp_Fields>;
  variance?: Maybe<Code_Metrics_By_Project_V1_Variance_Fields>;
};


/** aggregate fields of "code_metrics_by_project_v1" */
export type Code_Metrics_By_Project_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Code_Metrics_By_Project_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Code_Metrics_By_Project_V1_Avg_Fields = {
  __typename?: 'code_metrics_by_project_v1_avg_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "code_metrics_by_project_v1". All fields are combined with a logical 'AND'. */
export type Code_Metrics_By_Project_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Code_Metrics_By_Project_V1_Bool_Exp>>;
  _not?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Code_Metrics_By_Project_V1_Bool_Exp>>;
  active_developer_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  closed_issue_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  commit_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  contributor_count?: InputMaybe<Float8_Comparison_Exp>;
  contributor_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  event_source?: InputMaybe<String_Comparison_Exp>;
  first_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  fork_count?: InputMaybe<Bigint_Comparison_Exp>;
  fulltime_developer_average_6_months?: InputMaybe<Float8_Comparison_Exp>;
  last_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  merged_pull_request_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  new_contributor_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  opened_issue_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  opened_pull_request_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
  repository_count?: InputMaybe<Bigint_Comparison_Exp>;
  star_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Code_Metrics_By_Project_V1_Max_Fields = {
  __typename?: 'code_metrics_by_project_v1_max_fields';
  active_developer_count_6_months?: Maybe<Scalars['float8']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  commit_count_6_months?: Maybe<Scalars['float8']['output']>;
  contributor_count?: Maybe<Scalars['float8']['output']>;
  contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  fork_count?: Maybe<Scalars['bigint']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  repository_count?: Maybe<Scalars['bigint']['output']>;
  star_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Code_Metrics_By_Project_V1_Min_Fields = {
  __typename?: 'code_metrics_by_project_v1_min_fields';
  active_developer_count_6_months?: Maybe<Scalars['float8']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  commit_count_6_months?: Maybe<Scalars['float8']['output']>;
  contributor_count?: Maybe<Scalars['float8']['output']>;
  contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  fork_count?: Maybe<Scalars['bigint']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  repository_count?: Maybe<Scalars['bigint']['output']>;
  star_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "code_metrics_by_project_v1". */
export type Code_Metrics_By_Project_V1_Order_By = {
  active_developer_count_6_months?: InputMaybe<Order_By>;
  closed_issue_count_6_months?: InputMaybe<Order_By>;
  commit_count_6_months?: InputMaybe<Order_By>;
  contributor_count?: InputMaybe<Order_By>;
  contributor_count_6_months?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  event_source?: InputMaybe<Order_By>;
  first_commit_date?: InputMaybe<Order_By>;
  fork_count?: InputMaybe<Order_By>;
  fulltime_developer_average_6_months?: InputMaybe<Order_By>;
  last_commit_date?: InputMaybe<Order_By>;
  merged_pull_request_count_6_months?: InputMaybe<Order_By>;
  new_contributor_count_6_months?: InputMaybe<Order_By>;
  opened_issue_count_6_months?: InputMaybe<Order_By>;
  opened_pull_request_count_6_months?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
  repository_count?: InputMaybe<Order_By>;
  star_count?: InputMaybe<Order_By>;
};

/** select columns of table "code_metrics_by_project_v1" */
export enum Code_Metrics_By_Project_V1_Select_Column {
  /** column name */
  ActiveDeveloperCount_6Months = 'active_developer_count_6_months',
  /** column name */
  ClosedIssueCount_6Months = 'closed_issue_count_6_months',
  /** column name */
  CommitCount_6Months = 'commit_count_6_months',
  /** column name */
  ContributorCount = 'contributor_count',
  /** column name */
  ContributorCount_6Months = 'contributor_count_6_months',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EventSource = 'event_source',
  /** column name */
  FirstCommitDate = 'first_commit_date',
  /** column name */
  ForkCount = 'fork_count',
  /** column name */
  FulltimeDeveloperAverage_6Months = 'fulltime_developer_average_6_months',
  /** column name */
  LastCommitDate = 'last_commit_date',
  /** column name */
  MergedPullRequestCount_6Months = 'merged_pull_request_count_6_months',
  /** column name */
  NewContributorCount_6Months = 'new_contributor_count_6_months',
  /** column name */
  OpenedIssueCount_6Months = 'opened_issue_count_6_months',
  /** column name */
  OpenedPullRequestCount_6Months = 'opened_pull_request_count_6_months',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source',
  /** column name */
  RepositoryCount = 'repository_count',
  /** column name */
  StarCount = 'star_count'
}

/** aggregate stddev on columns */
export type Code_Metrics_By_Project_V1_Stddev_Fields = {
  __typename?: 'code_metrics_by_project_v1_stddev_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Code_Metrics_By_Project_V1_Stddev_Pop_Fields = {
  __typename?: 'code_metrics_by_project_v1_stddev_pop_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Code_Metrics_By_Project_V1_Stddev_Samp_Fields = {
  __typename?: 'code_metrics_by_project_v1_stddev_samp_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "code_metrics_by_project_v1" */
export type Code_Metrics_By_Project_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Code_Metrics_By_Project_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Code_Metrics_By_Project_V1_Stream_Cursor_Value_Input = {
  active_developer_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  closed_issue_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  commit_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  contributor_count?: InputMaybe<Scalars['float8']['input']>;
  contributor_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  event_source?: InputMaybe<Scalars['String']['input']>;
  first_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  fork_count?: InputMaybe<Scalars['bigint']['input']>;
  fulltime_developer_average_6_months?: InputMaybe<Scalars['float8']['input']>;
  last_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  merged_pull_request_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  new_contributor_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  opened_issue_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  opened_pull_request_count_6_months?: InputMaybe<Scalars['float8']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
  repository_count?: InputMaybe<Scalars['bigint']['input']>;
  star_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Code_Metrics_By_Project_V1_Sum_Fields = {
  __typename?: 'code_metrics_by_project_v1_sum_fields';
  active_developer_count_6_months?: Maybe<Scalars['float8']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  commit_count_6_months?: Maybe<Scalars['float8']['output']>;
  contributor_count?: Maybe<Scalars['float8']['output']>;
  contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  fork_count?: Maybe<Scalars['bigint']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['float8']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['float8']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['float8']['output']>;
  repository_count?: Maybe<Scalars['bigint']['output']>;
  star_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Code_Metrics_By_Project_V1_Var_Pop_Fields = {
  __typename?: 'code_metrics_by_project_v1_var_pop_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Code_Metrics_By_Project_V1_Var_Samp_Fields = {
  __typename?: 'code_metrics_by_project_v1_var_samp_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Code_Metrics_By_Project_V1_Variance_Fields = {
  __typename?: 'code_metrics_by_project_v1_variance_fields';
  active_developer_count_6_months?: Maybe<Scalars['Float']['output']>;
  closed_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  commit_count_6_months?: Maybe<Scalars['Float']['output']>;
  contributor_count?: Maybe<Scalars['Float']['output']>;
  contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  fork_count?: Maybe<Scalars['Float']['output']>;
  fulltime_developer_average_6_months?: Maybe<Scalars['Float']['output']>;
  merged_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributor_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_issue_count_6_months?: Maybe<Scalars['Float']['output']>;
  opened_pull_request_count_6_months?: Maybe<Scalars['Float']['output']>;
  repository_count?: Maybe<Scalars['Float']['output']>;
  star_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "collections_v1" */
export type Collections_V1 = {
  __typename?: 'collections_v1';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "collections_v1" */
export type Collections_V1_Aggregate = {
  __typename?: 'collections_v1_aggregate';
  aggregate?: Maybe<Collections_V1_Aggregate_Fields>;
  nodes: Array<Collections_V1>;
};

/** aggregate fields of "collections_v1" */
export type Collections_V1_Aggregate_Fields = {
  __typename?: 'collections_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Collections_V1_Max_Fields>;
  min?: Maybe<Collections_V1_Min_Fields>;
};


/** aggregate fields of "collections_v1" */
export type Collections_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collections_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "collections_v1". All fields are combined with a logical 'AND'. */
export type Collections_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_V1_Bool_Exp>>;
  _not?: InputMaybe<Collections_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_V1_Bool_Exp>>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  collection_namespace?: InputMaybe<String_Comparison_Exp>;
  collection_source?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Collections_V1_Max_Fields = {
  __typename?: 'collections_v1_max_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Collections_V1_Min_Fields = {
  __typename?: 'collections_v1_min_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "collections_v1". */
export type Collections_V1_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  collection_namespace?: InputMaybe<Order_By>;
  collection_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
};

/** select columns of table "collections_v1" */
export enum Collections_V1_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  CollectionNamespace = 'collection_namespace',
  /** column name */
  CollectionSource = 'collection_source',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name'
}

/** Streaming cursor of the table "collections_v1" */
export type Collections_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_V1_Stream_Cursor_Value_Input = {
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  collection_namespace?: InputMaybe<Scalars['String']['input']>;
  collection_source?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "contracts_v0" */
export type Contracts_V0 = {
  __typename?: 'contracts_v0';
  artifact_source?: Maybe<Scalars['String']['output']>;
  contract_address?: Maybe<Scalars['String']['output']>;
  root_deployer_address?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "contracts_v0" */
export type Contracts_V0_Aggregate = {
  __typename?: 'contracts_v0_aggregate';
  aggregate?: Maybe<Contracts_V0_Aggregate_Fields>;
  nodes: Array<Contracts_V0>;
};

/** aggregate fields of "contracts_v0" */
export type Contracts_V0_Aggregate_Fields = {
  __typename?: 'contracts_v0_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contracts_V0_Max_Fields>;
  min?: Maybe<Contracts_V0_Min_Fields>;
};


/** aggregate fields of "contracts_v0" */
export type Contracts_V0_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contracts_V0_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "contracts_v0". All fields are combined with a logical 'AND'. */
export type Contracts_V0_Bool_Exp = {
  _and?: InputMaybe<Array<Contracts_V0_Bool_Exp>>;
  _not?: InputMaybe<Contracts_V0_Bool_Exp>;
  _or?: InputMaybe<Array<Contracts_V0_Bool_Exp>>;
  artifact_source?: InputMaybe<String_Comparison_Exp>;
  contract_address?: InputMaybe<String_Comparison_Exp>;
  root_deployer_address?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Contracts_V0_Max_Fields = {
  __typename?: 'contracts_v0_max_fields';
  artifact_source?: Maybe<Scalars['String']['output']>;
  contract_address?: Maybe<Scalars['String']['output']>;
  root_deployer_address?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Contracts_V0_Min_Fields = {
  __typename?: 'contracts_v0_min_fields';
  artifact_source?: Maybe<Scalars['String']['output']>;
  contract_address?: Maybe<Scalars['String']['output']>;
  root_deployer_address?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "contracts_v0". */
export type Contracts_V0_Order_By = {
  artifact_source?: InputMaybe<Order_By>;
  contract_address?: InputMaybe<Order_By>;
  root_deployer_address?: InputMaybe<Order_By>;
};

/** select columns of table "contracts_v0" */
export enum Contracts_V0_Select_Column {
  /** column name */
  ArtifactSource = 'artifact_source',
  /** column name */
  ContractAddress = 'contract_address',
  /** column name */
  RootDeployerAddress = 'root_deployer_address'
}

/** Streaming cursor of the table "contracts_v0" */
export type Contracts_V0_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contracts_V0_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contracts_V0_Stream_Cursor_Value_Input = {
  artifact_source?: InputMaybe<Scalars['String']['input']>;
  contract_address?: InputMaybe<Scalars['String']['input']>;
  root_deployer_address?: InputMaybe<Scalars['String']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "event_indexing_status_by_project_v1" */
export type Event_Indexing_Status_By_Project_V1 = {
  __typename?: 'event_indexing_status_by_project_v1';
  event_source?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  eventful_day_count?: Maybe<Scalars['bigint']['output']>;
  first_event_date?: Maybe<Scalars['timestamptz']['output']>;
  last_event_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "event_indexing_status_by_project_v1" */
export type Event_Indexing_Status_By_Project_V1_Aggregate = {
  __typename?: 'event_indexing_status_by_project_v1_aggregate';
  aggregate?: Maybe<Event_Indexing_Status_By_Project_V1_Aggregate_Fields>;
  nodes: Array<Event_Indexing_Status_By_Project_V1>;
};

/** aggregate fields of "event_indexing_status_by_project_v1" */
export type Event_Indexing_Status_By_Project_V1_Aggregate_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_aggregate_fields';
  avg?: Maybe<Event_Indexing_Status_By_Project_V1_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Event_Indexing_Status_By_Project_V1_Max_Fields>;
  min?: Maybe<Event_Indexing_Status_By_Project_V1_Min_Fields>;
  stddev?: Maybe<Event_Indexing_Status_By_Project_V1_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Indexing_Status_By_Project_V1_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Indexing_Status_By_Project_V1_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Indexing_Status_By_Project_V1_Sum_Fields>;
  var_pop?: Maybe<Event_Indexing_Status_By_Project_V1_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Indexing_Status_By_Project_V1_Var_Samp_Fields>;
  variance?: Maybe<Event_Indexing_Status_By_Project_V1_Variance_Fields>;
};


/** aggregate fields of "event_indexing_status_by_project_v1" */
export type Event_Indexing_Status_By_Project_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Event_Indexing_Status_By_Project_V1_Avg_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_avg_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "event_indexing_status_by_project_v1". All fields are combined with a logical 'AND'. */
export type Event_Indexing_Status_By_Project_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Bool_Exp>>;
  _not?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Bool_Exp>>;
  event_source?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  eventful_day_count?: InputMaybe<Bigint_Comparison_Exp>;
  first_event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_event_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Event_Indexing_Status_By_Project_V1_Max_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_max_fields';
  event_source?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  eventful_day_count?: Maybe<Scalars['bigint']['output']>;
  first_event_date?: Maybe<Scalars['timestamptz']['output']>;
  last_event_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_Indexing_Status_By_Project_V1_Min_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_min_fields';
  event_source?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  eventful_day_count?: Maybe<Scalars['bigint']['output']>;
  first_event_date?: Maybe<Scalars['timestamptz']['output']>;
  last_event_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "event_indexing_status_by_project_v1". */
export type Event_Indexing_Status_By_Project_V1_Order_By = {
  event_source?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  eventful_day_count?: InputMaybe<Order_By>;
  first_event_date?: InputMaybe<Order_By>;
  last_event_date?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
};

/** select columns of table "event_indexing_status_by_project_v1" */
export enum Event_Indexing_Status_By_Project_V1_Select_Column {
  /** column name */
  EventSource = 'event_source',
  /** column name */
  EventType = 'event_type',
  /** column name */
  EventfulDayCount = 'eventful_day_count',
  /** column name */
  FirstEventDate = 'first_event_date',
  /** column name */
  LastEventDate = 'last_event_date',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source'
}

/** aggregate stddev on columns */
export type Event_Indexing_Status_By_Project_V1_Stddev_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_stddev_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Event_Indexing_Status_By_Project_V1_Stddev_Pop_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_stddev_pop_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Event_Indexing_Status_By_Project_V1_Stddev_Samp_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_stddev_samp_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "event_indexing_status_by_project_v1" */
export type Event_Indexing_Status_By_Project_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Indexing_Status_By_Project_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Indexing_Status_By_Project_V1_Stream_Cursor_Value_Input = {
  event_source?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  eventful_day_count?: InputMaybe<Scalars['bigint']['input']>;
  first_event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  last_event_date?: InputMaybe<Scalars['timestamptz']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Event_Indexing_Status_By_Project_V1_Sum_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_sum_fields';
  eventful_day_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Event_Indexing_Status_By_Project_V1_Var_Pop_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_var_pop_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Event_Indexing_Status_By_Project_V1_Var_Samp_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_var_samp_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Event_Indexing_Status_By_Project_V1_Variance_Fields = {
  __typename?: 'event_indexing_status_by_project_v1_variance_fields';
  eventful_day_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "event_types_v1" */
export type Event_Types_V1 = {
  __typename?: 'event_types_v1';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "event_types_v1" */
export type Event_Types_V1_Aggregate = {
  __typename?: 'event_types_v1_aggregate';
  aggregate?: Maybe<Event_Types_V1_Aggregate_Fields>;
  nodes: Array<Event_Types_V1>;
};

/** aggregate fields of "event_types_v1" */
export type Event_Types_V1_Aggregate_Fields = {
  __typename?: 'event_types_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Event_Types_V1_Max_Fields>;
  min?: Maybe<Event_Types_V1_Min_Fields>;
};


/** aggregate fields of "event_types_v1" */
export type Event_Types_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Types_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "event_types_v1". All fields are combined with a logical 'AND'. */
export type Event_Types_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Types_V1_Bool_Exp>>;
  _not?: InputMaybe<Event_Types_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Types_V1_Bool_Exp>>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Event_Types_V1_Max_Fields = {
  __typename?: 'event_types_v1_max_fields';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_Types_V1_Min_Fields = {
  __typename?: 'event_types_v1_min_fields';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "event_types_v1". */
export type Event_Types_V1_Order_By = {
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "event_types_v1" */
export enum Event_Types_V1_Select_Column {
  /** column name */
  EventType = 'event_type'
}

/** Streaming cursor of the table "event_types_v1" */
export type Event_Types_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Types_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Types_V1_Stream_Cursor_Value_Input = {
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact = {
  __typename?: 'events_daily_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate = {
  __typename?: 'events_daily_to_artifact_aggregate';
  aggregate?: Maybe<Events_Daily_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Artifact>;
};

/** aggregate fields of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_daily_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Daily_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Artifact_Avg_Fields = {
  __typename?: 'events_daily_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Artifact_Max_Fields = {
  __typename?: 'events_daily_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Artifact_Min_Fields = {
  __typename?: 'events_daily_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_artifact". */
export type Events_Daily_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_artifact" */
export enum Events_Daily_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Artifact_Stddev_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Artifact_Sum_Fields = {
  __typename?: 'events_daily_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_daily_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_daily_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Artifact_Variance_Fields = {
  __typename?: 'events_daily_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_to_collection" */
export type Events_Daily_To_Collection = {
  __typename?: 'events_daily_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate = {
  __typename?: 'events_daily_to_collection_aggregate';
  aggregate?: Maybe<Events_Daily_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Collection>;
};

/** aggregate fields of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate_Fields = {
  __typename?: 'events_daily_to_collection_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Collection_Max_Fields>;
  min?: Maybe<Events_Daily_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Collection_Avg_Fields = {
  __typename?: 'events_daily_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Collection_Max_Fields = {
  __typename?: 'events_daily_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Collection_Min_Fields = {
  __typename?: 'events_daily_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_collection". */
export type Events_Daily_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_collection" */
export enum Events_Daily_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Collection_Stddev_Fields = {
  __typename?: 'events_daily_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_collection" */
export type Events_Daily_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Collection_Sum_Fields = {
  __typename?: 'events_daily_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_daily_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_daily_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Collection_Variance_Fields = {
  __typename?: 'events_daily_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_to_project" */
export type Events_Daily_To_Project = {
  __typename?: 'events_daily_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate = {
  __typename?: 'events_daily_to_project_aggregate';
  aggregate?: Maybe<Events_Daily_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Project>;
};

/** aggregate fields of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate_Fields = {
  __typename?: 'events_daily_to_project_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Project_Max_Fields>;
  min?: Maybe<Events_Daily_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Project_Avg_Fields = {
  __typename?: 'events_daily_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_project". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Project_Max_Fields = {
  __typename?: 'events_daily_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Project_Min_Fields = {
  __typename?: 'events_daily_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_project". */
export type Events_Daily_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_project" */
export enum Events_Daily_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Project_Stddev_Fields = {
  __typename?: 'events_daily_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_project" */
export type Events_Daily_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Project_Sum_Fields = {
  __typename?: 'events_daily_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Project_Var_Pop_Fields = {
  __typename?: 'events_daily_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Project_Var_Samp_Fields = {
  __typename?: 'events_daily_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Project_Variance_Fields = {
  __typename?: 'events_daily_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact = {
  __typename?: 'events_monthly_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate = {
  __typename?: 'events_monthly_to_artifact_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Artifact>;
};

/** aggregate fields of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_monthly_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Artifact_Avg_Fields = {
  __typename?: 'events_monthly_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Artifact_Max_Fields = {
  __typename?: 'events_monthly_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Artifact_Min_Fields = {
  __typename?: 'events_monthly_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_artifact". */
export type Events_Monthly_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_artifact" */
export enum Events_Monthly_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Artifact_Stddev_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Artifact_Sum_Fields = {
  __typename?: 'events_monthly_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Artifact_Variance_Fields = {
  __typename?: 'events_monthly_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection = {
  __typename?: 'events_monthly_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate = {
  __typename?: 'events_monthly_to_collection_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Collection>;
};

/** aggregate fields of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate_Fields = {
  __typename?: 'events_monthly_to_collection_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Collection_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Collection_Avg_Fields = {
  __typename?: 'events_monthly_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Collection_Max_Fields = {
  __typename?: 'events_monthly_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Collection_Min_Fields = {
  __typename?: 'events_monthly_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_collection". */
export type Events_Monthly_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_collection" */
export enum Events_Monthly_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Collection_Stddev_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Collection_Sum_Fields = {
  __typename?: 'events_monthly_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Collection_Variance_Fields = {
  __typename?: 'events_monthly_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_project" */
export type Events_Monthly_To_Project = {
  __typename?: 'events_monthly_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate = {
  __typename?: 'events_monthly_to_project_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Project>;
};

/** aggregate fields of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate_Fields = {
  __typename?: 'events_monthly_to_project_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Project_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Project_Avg_Fields = {
  __typename?: 'events_monthly_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_project". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Project_Max_Fields = {
  __typename?: 'events_monthly_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Project_Min_Fields = {
  __typename?: 'events_monthly_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_project". */
export type Events_Monthly_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_project" */
export enum Events_Monthly_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Project_Stddev_Fields = {
  __typename?: 'events_monthly_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_project" */
export type Events_Monthly_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Project_Sum_Fields = {
  __typename?: 'events_monthly_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Project_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Project_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Project_Variance_Fields = {
  __typename?: 'events_monthly_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact = {
  __typename?: 'events_weekly_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate = {
  __typename?: 'events_weekly_to_artifact_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Artifact>;
};

/** aggregate fields of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_weekly_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Artifact_Avg_Fields = {
  __typename?: 'events_weekly_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Artifact_Max_Fields = {
  __typename?: 'events_weekly_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Artifact_Min_Fields = {
  __typename?: 'events_weekly_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_artifact". */
export type Events_Weekly_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_artifact" */
export enum Events_Weekly_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Artifact_Stddev_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Artifact_Sum_Fields = {
  __typename?: 'events_weekly_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Artifact_Variance_Fields = {
  __typename?: 'events_weekly_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection = {
  __typename?: 'events_weekly_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate = {
  __typename?: 'events_weekly_to_collection_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Collection>;
};

/** aggregate fields of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate_Fields = {
  __typename?: 'events_weekly_to_collection_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Collection_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Collection_Avg_Fields = {
  __typename?: 'events_weekly_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Collection_Max_Fields = {
  __typename?: 'events_weekly_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Collection_Min_Fields = {
  __typename?: 'events_weekly_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_collection". */
export type Events_Weekly_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_collection" */
export enum Events_Weekly_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Collection_Stddev_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Collection_Sum_Fields = {
  __typename?: 'events_weekly_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Collection_Variance_Fields = {
  __typename?: 'events_weekly_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_project" */
export type Events_Weekly_To_Project = {
  __typename?: 'events_weekly_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate = {
  __typename?: 'events_weekly_to_project_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Project>;
};

/** aggregate fields of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate_Fields = {
  __typename?: 'events_weekly_to_project_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Project_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Project_Avg_Fields = {
  __typename?: 'events_weekly_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_project". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Project_Max_Fields = {
  __typename?: 'events_weekly_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Project_Min_Fields = {
  __typename?: 'events_weekly_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_project". */
export type Events_Weekly_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_project" */
export enum Events_Weekly_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Project_Stddev_Fields = {
  __typename?: 'events_weekly_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_project" */
export type Events_Weekly_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Project_Sum_Fields = {
  __typename?: 'events_weekly_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Project_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Project_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Project_Variance_Fields = {
  __typename?: 'events_weekly_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "onchain_metrics_by_project_v1" */
export type Onchain_Metrics_By_Project_V1 = {
  __typename?: 'onchain_metrics_by_project_v1';
  active_contract_count_90_days?: Maybe<Scalars['float8']['output']>;
  address_count?: Maybe<Scalars['float8']['output']>;
  address_count_90_days?: Maybe<Scalars['float8']['output']>;
  days_since_first_transaction?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  gas_fees_sum?: Maybe<Scalars['float8']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['float8']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  new_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  transaction_count?: Maybe<Scalars['float8']['output']>;
  transaction_count_6_months?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "onchain_metrics_by_project_v1" */
export type Onchain_Metrics_By_Project_V1_Aggregate = {
  __typename?: 'onchain_metrics_by_project_v1_aggregate';
  aggregate?: Maybe<Onchain_Metrics_By_Project_V1_Aggregate_Fields>;
  nodes: Array<Onchain_Metrics_By_Project_V1>;
};

/** aggregate fields of "onchain_metrics_by_project_v1" */
export type Onchain_Metrics_By_Project_V1_Aggregate_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_aggregate_fields';
  avg?: Maybe<Onchain_Metrics_By_Project_V1_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Onchain_Metrics_By_Project_V1_Max_Fields>;
  min?: Maybe<Onchain_Metrics_By_Project_V1_Min_Fields>;
  stddev?: Maybe<Onchain_Metrics_By_Project_V1_Stddev_Fields>;
  stddev_pop?: Maybe<Onchain_Metrics_By_Project_V1_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Onchain_Metrics_By_Project_V1_Stddev_Samp_Fields>;
  sum?: Maybe<Onchain_Metrics_By_Project_V1_Sum_Fields>;
  var_pop?: Maybe<Onchain_Metrics_By_Project_V1_Var_Pop_Fields>;
  var_samp?: Maybe<Onchain_Metrics_By_Project_V1_Var_Samp_Fields>;
  variance?: Maybe<Onchain_Metrics_By_Project_V1_Variance_Fields>;
};


/** aggregate fields of "onchain_metrics_by_project_v1" */
export type Onchain_Metrics_By_Project_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Onchain_Metrics_By_Project_V1_Avg_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_avg_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "onchain_metrics_by_project_v1". All fields are combined with a logical 'AND'. */
export type Onchain_Metrics_By_Project_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Bool_Exp>>;
  _not?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Bool_Exp>>;
  active_contract_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  address_count?: InputMaybe<Float8_Comparison_Exp>;
  address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  days_since_first_transaction?: InputMaybe<Float8_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  event_source?: InputMaybe<String_Comparison_Exp>;
  gas_fees_sum?: InputMaybe<Float8_Comparison_Exp>;
  gas_fees_sum_6_months?: InputMaybe<Float8_Comparison_Exp>;
  high_activity_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  low_activity_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  medium_activity_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  multi_project_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  new_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
  returning_address_count_90_days?: InputMaybe<Float8_Comparison_Exp>;
  transaction_count?: InputMaybe<Float8_Comparison_Exp>;
  transaction_count_6_months?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Onchain_Metrics_By_Project_V1_Max_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_max_fields';
  active_contract_count_90_days?: Maybe<Scalars['float8']['output']>;
  address_count?: Maybe<Scalars['float8']['output']>;
  address_count_90_days?: Maybe<Scalars['float8']['output']>;
  days_since_first_transaction?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  gas_fees_sum?: Maybe<Scalars['float8']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['float8']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  new_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  transaction_count?: Maybe<Scalars['float8']['output']>;
  transaction_count_6_months?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Onchain_Metrics_By_Project_V1_Min_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_min_fields';
  active_contract_count_90_days?: Maybe<Scalars['float8']['output']>;
  address_count?: Maybe<Scalars['float8']['output']>;
  address_count_90_days?: Maybe<Scalars['float8']['output']>;
  days_since_first_transaction?: Maybe<Scalars['float8']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  event_source?: Maybe<Scalars['String']['output']>;
  gas_fees_sum?: Maybe<Scalars['float8']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['float8']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  new_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  transaction_count?: Maybe<Scalars['float8']['output']>;
  transaction_count_6_months?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "onchain_metrics_by_project_v1". */
export type Onchain_Metrics_By_Project_V1_Order_By = {
  active_contract_count_90_days?: InputMaybe<Order_By>;
  address_count?: InputMaybe<Order_By>;
  address_count_90_days?: InputMaybe<Order_By>;
  days_since_first_transaction?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  event_source?: InputMaybe<Order_By>;
  gas_fees_sum?: InputMaybe<Order_By>;
  gas_fees_sum_6_months?: InputMaybe<Order_By>;
  high_activity_address_count_90_days?: InputMaybe<Order_By>;
  low_activity_address_count_90_days?: InputMaybe<Order_By>;
  medium_activity_address_count_90_days?: InputMaybe<Order_By>;
  multi_project_address_count_90_days?: InputMaybe<Order_By>;
  new_address_count_90_days?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
  returning_address_count_90_days?: InputMaybe<Order_By>;
  transaction_count?: InputMaybe<Order_By>;
  transaction_count_6_months?: InputMaybe<Order_By>;
};

/** select columns of table "onchain_metrics_by_project_v1" */
export enum Onchain_Metrics_By_Project_V1_Select_Column {
  /** column name */
  ActiveContractCount_90Days = 'active_contract_count_90_days',
  /** column name */
  AddressCount = 'address_count',
  /** column name */
  AddressCount_90Days = 'address_count_90_days',
  /** column name */
  DaysSinceFirstTransaction = 'days_since_first_transaction',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EventSource = 'event_source',
  /** column name */
  GasFeesSum = 'gas_fees_sum',
  /** column name */
  GasFeesSum_6Months = 'gas_fees_sum_6_months',
  /** column name */
  HighActivityAddressCount_90Days = 'high_activity_address_count_90_days',
  /** column name */
  LowActivityAddressCount_90Days = 'low_activity_address_count_90_days',
  /** column name */
  MediumActivityAddressCount_90Days = 'medium_activity_address_count_90_days',
  /** column name */
  MultiProjectAddressCount_90Days = 'multi_project_address_count_90_days',
  /** column name */
  NewAddressCount_90Days = 'new_address_count_90_days',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source',
  /** column name */
  ReturningAddressCount_90Days = 'returning_address_count_90_days',
  /** column name */
  TransactionCount = 'transaction_count',
  /** column name */
  TransactionCount_6Months = 'transaction_count_6_months'
}

/** aggregate stddev on columns */
export type Onchain_Metrics_By_Project_V1_Stddev_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_stddev_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Onchain_Metrics_By_Project_V1_Stddev_Pop_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_stddev_pop_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Onchain_Metrics_By_Project_V1_Stddev_Samp_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_stddev_samp_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "onchain_metrics_by_project_v1" */
export type Onchain_Metrics_By_Project_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Onchain_Metrics_By_Project_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Onchain_Metrics_By_Project_V1_Stream_Cursor_Value_Input = {
  active_contract_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  address_count?: InputMaybe<Scalars['float8']['input']>;
  address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  days_since_first_transaction?: InputMaybe<Scalars['float8']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  event_source?: InputMaybe<Scalars['String']['input']>;
  gas_fees_sum?: InputMaybe<Scalars['float8']['input']>;
  gas_fees_sum_6_months?: InputMaybe<Scalars['float8']['input']>;
  high_activity_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  low_activity_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  medium_activity_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  multi_project_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  new_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
  returning_address_count_90_days?: InputMaybe<Scalars['float8']['input']>;
  transaction_count?: InputMaybe<Scalars['float8']['input']>;
  transaction_count_6_months?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Onchain_Metrics_By_Project_V1_Sum_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_sum_fields';
  active_contract_count_90_days?: Maybe<Scalars['float8']['output']>;
  address_count?: Maybe<Scalars['float8']['output']>;
  address_count_90_days?: Maybe<Scalars['float8']['output']>;
  days_since_first_transaction?: Maybe<Scalars['float8']['output']>;
  gas_fees_sum?: Maybe<Scalars['float8']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['float8']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  new_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['float8']['output']>;
  transaction_count?: Maybe<Scalars['float8']['output']>;
  transaction_count_6_months?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Onchain_Metrics_By_Project_V1_Var_Pop_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_var_pop_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Onchain_Metrics_By_Project_V1_Var_Samp_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_var_samp_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Onchain_Metrics_By_Project_V1_Variance_Fields = {
  __typename?: 'onchain_metrics_by_project_v1_variance_fields';
  active_contract_count_90_days?: Maybe<Scalars['Float']['output']>;
  address_count?: Maybe<Scalars['Float']['output']>;
  address_count_90_days?: Maybe<Scalars['Float']['output']>;
  days_since_first_transaction?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum?: Maybe<Scalars['Float']['output']>;
  gas_fees_sum_6_months?: Maybe<Scalars['Float']['output']>;
  high_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  low_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  medium_activity_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  multi_project_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  new_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  returning_address_count_90_days?: Maybe<Scalars['Float']['output']>;
  transaction_count?: Maybe<Scalars['Float']['output']>;
  transaction_count_6_months?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "projects_by_collection_v1" */
export type Projects_By_Collection_V1 = {
  __typename?: 'projects_by_collection_v1';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "projects_by_collection_v1" */
export type Projects_By_Collection_V1_Aggregate = {
  __typename?: 'projects_by_collection_v1_aggregate';
  aggregate?: Maybe<Projects_By_Collection_V1_Aggregate_Fields>;
  nodes: Array<Projects_By_Collection_V1>;
};

/** aggregate fields of "projects_by_collection_v1" */
export type Projects_By_Collection_V1_Aggregate_Fields = {
  __typename?: 'projects_by_collection_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_By_Collection_V1_Max_Fields>;
  min?: Maybe<Projects_By_Collection_V1_Min_Fields>;
};


/** aggregate fields of "projects_by_collection_v1" */
export type Projects_By_Collection_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_By_Collection_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "projects_by_collection_v1". All fields are combined with a logical 'AND'. */
export type Projects_By_Collection_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_By_Collection_V1_Bool_Exp>>;
  _not?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_By_Collection_V1_Bool_Exp>>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  collection_namespace?: InputMaybe<String_Comparison_Exp>;
  collection_source?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Projects_By_Collection_V1_Max_Fields = {
  __typename?: 'projects_by_collection_v1_max_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Projects_By_Collection_V1_Min_Fields = {
  __typename?: 'projects_by_collection_v1_min_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_namespace?: Maybe<Scalars['String']['output']>;
  collection_source?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "projects_by_collection_v1". */
export type Projects_By_Collection_V1_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  collection_namespace?: InputMaybe<Order_By>;
  collection_source?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
};

/** select columns of table "projects_by_collection_v1" */
export enum Projects_By_Collection_V1_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  CollectionNamespace = 'collection_namespace',
  /** column name */
  CollectionSource = 'collection_source',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source'
}

/** Streaming cursor of the table "projects_by_collection_v1" */
export type Projects_By_Collection_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_By_Collection_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_By_Collection_V1_Stream_Cursor_Value_Input = {
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  collection_namespace?: InputMaybe<Scalars['String']['input']>;
  collection_source?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "projects_v1" */
export type Projects_V1 = {
  __typename?: 'projects_v1';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "projects_v1" */
export type Projects_V1_Aggregate = {
  __typename?: 'projects_v1_aggregate';
  aggregate?: Maybe<Projects_V1_Aggregate_Fields>;
  nodes: Array<Projects_V1>;
};

/** aggregate fields of "projects_v1" */
export type Projects_V1_Aggregate_Fields = {
  __typename?: 'projects_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_V1_Max_Fields>;
  min?: Maybe<Projects_V1_Min_Fields>;
};


/** aggregate fields of "projects_v1" */
export type Projects_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "projects_v1". All fields are combined with a logical 'AND'. */
export type Projects_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_V1_Bool_Exp>>;
  _not?: InputMaybe<Projects_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_V1_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_namespace?: InputMaybe<String_Comparison_Exp>;
  project_source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Projects_V1_Max_Fields = {
  __typename?: 'projects_v1_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Projects_V1_Min_Fields = {
  __typename?: 'projects_v1_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_namespace?: Maybe<Scalars['String']['output']>;
  project_source?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "projects_v1". */
export type Projects_V1_Order_By = {
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_namespace?: InputMaybe<Order_By>;
  project_source?: InputMaybe<Order_By>;
};

/** select columns of table "projects_v1" */
export enum Projects_V1_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectNamespace = 'project_namespace',
  /** column name */
  ProjectSource = 'project_source'
}

/** Streaming cursor of the table "projects_v1" */
export type Projects_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_V1_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_namespace?: InputMaybe<Scalars['String']['input']>;
  project_source?: InputMaybe<Scalars['String']['input']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "artifacts_by_project_v1" */
  artifacts_by_project_v1: Array<Artifacts_By_Project_V1>;
  /** fetch aggregated fields from the table: "artifacts_by_project_v1" */
  artifacts_by_project_v1_aggregate: Artifacts_By_Project_V1_Aggregate;
  /** fetch data from the table: "artifacts_v1" */
  artifacts_v1: Array<Artifacts_V1>;
  /** fetch aggregated fields from the table: "artifacts_v1" */
  artifacts_v1_aggregate: Artifacts_V1_Aggregate;
  /** fetch data from the table: "code_metrics_by_project_v1" */
  code_metrics_by_project_v1: Array<Code_Metrics_By_Project_V1>;
  /** fetch aggregated fields from the table: "code_metrics_by_project_v1" */
  code_metrics_by_project_v1_aggregate: Code_Metrics_By_Project_V1_Aggregate;
  /** fetch data from the table: "collections_v1" */
  collections_v1: Array<Collections_V1>;
  /** fetch aggregated fields from the table: "collections_v1" */
  collections_v1_aggregate: Collections_V1_Aggregate;
  /** fetch data from the table: "contracts_v0" */
  contracts_v0: Array<Contracts_V0>;
  /** fetch aggregated fields from the table: "contracts_v0" */
  contracts_v0_aggregate: Contracts_V0_Aggregate;
  /** fetch data from the table: "event_indexing_status_by_project_v1" */
  event_indexing_status_by_project_v1: Array<Event_Indexing_Status_By_Project_V1>;
  /** fetch aggregated fields from the table: "event_indexing_status_by_project_v1" */
  event_indexing_status_by_project_v1_aggregate: Event_Indexing_Status_By_Project_V1_Aggregate;
  /** fetch data from the table: "event_types_v1" */
  event_types_v1: Array<Event_Types_V1>;
  /** fetch aggregated fields from the table: "event_types_v1" */
  event_types_v1_aggregate: Event_Types_V1_Aggregate;
  /** fetch data from the table: "events_daily_to_artifact" */
  events_daily_to_artifact: Array<Events_Daily_To_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_to_artifact" */
  events_daily_to_artifact_aggregate: Events_Daily_To_Artifact_Aggregate;
  /** fetch data from the table: "events_daily_to_collection" */
  events_daily_to_collection: Array<Events_Daily_To_Collection>;
  /** fetch aggregated fields from the table: "events_daily_to_collection" */
  events_daily_to_collection_aggregate: Events_Daily_To_Collection_Aggregate;
  /** fetch data from the table: "events_daily_to_project" */
  events_daily_to_project: Array<Events_Daily_To_Project>;
  /** fetch aggregated fields from the table: "events_daily_to_project" */
  events_daily_to_project_aggregate: Events_Daily_To_Project_Aggregate;
  /** fetch data from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact: Array<Events_Monthly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact_aggregate: Events_Monthly_To_Artifact_Aggregate;
  /** fetch data from the table: "events_monthly_to_collection" */
  events_monthly_to_collection: Array<Events_Monthly_To_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_to_collection" */
  events_monthly_to_collection_aggregate: Events_Monthly_To_Collection_Aggregate;
  /** fetch data from the table: "events_monthly_to_project" */
  events_monthly_to_project: Array<Events_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "events_monthly_to_project" */
  events_monthly_to_project_aggregate: Events_Monthly_To_Project_Aggregate;
  /** fetch data from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact: Array<Events_Weekly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact_aggregate: Events_Weekly_To_Artifact_Aggregate;
  /** fetch data from the table: "events_weekly_to_collection" */
  events_weekly_to_collection: Array<Events_Weekly_To_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_to_collection" */
  events_weekly_to_collection_aggregate: Events_Weekly_To_Collection_Aggregate;
  /** fetch data from the table: "events_weekly_to_project" */
  events_weekly_to_project: Array<Events_Weekly_To_Project>;
  /** fetch aggregated fields from the table: "events_weekly_to_project" */
  events_weekly_to_project_aggregate: Events_Weekly_To_Project_Aggregate;
  /** fetch data from the table: "onchain_metrics_by_project_v1" */
  onchain_metrics_by_project_v1: Array<Onchain_Metrics_By_Project_V1>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_project_v1" */
  onchain_metrics_by_project_v1_aggregate: Onchain_Metrics_By_Project_V1_Aggregate;
  /** fetch data from the table: "projects_by_collection_v1" */
  projects_by_collection_v1: Array<Projects_By_Collection_V1>;
  /** fetch aggregated fields from the table: "projects_by_collection_v1" */
  projects_by_collection_v1_aggregate: Projects_By_Collection_V1_Aggregate;
  /** fetch data from the table: "projects_v1" */
  projects_v1: Array<Projects_V1>;
  /** fetch aggregated fields from the table: "projects_v1" */
  projects_v1_aggregate: Projects_V1_Aggregate;
  /** fetch data from the table: "users_v1" */
  users_v1: Array<Users_V1>;
  /** fetch aggregated fields from the table: "users_v1" */
  users_v1_aggregate: Users_V1_Aggregate;
};


export type Query_RootArtifacts_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_V1_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
};


export type Query_RootArtifacts_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_V1_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
};


export type Query_RootArtifacts_V1Args = {
  distinct_on?: InputMaybe<Array<Artifacts_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_V1_Order_By>>;
  where?: InputMaybe<Artifacts_V1_Bool_Exp>;
};


export type Query_RootArtifacts_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_V1_Order_By>>;
  where?: InputMaybe<Artifacts_V1_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
};


export type Query_RootCollections_V1Args = {
  distinct_on?: InputMaybe<Array<Collections_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_V1_Order_By>>;
  where?: InputMaybe<Collections_V1_Bool_Exp>;
};


export type Query_RootCollections_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_V1_Order_By>>;
  where?: InputMaybe<Collections_V1_Bool_Exp>;
};


export type Query_RootContracts_V0Args = {
  distinct_on?: InputMaybe<Array<Contracts_V0_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_V0_Order_By>>;
  where?: InputMaybe<Contracts_V0_Bool_Exp>;
};


export type Query_RootContracts_V0_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_V0_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_V0_Order_By>>;
  where?: InputMaybe<Contracts_V0_Bool_Exp>;
};


export type Query_RootEvent_Indexing_Status_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Order_By>>;
  where?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
};


export type Query_RootEvent_Indexing_Status_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Order_By>>;
  where?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
};


export type Query_RootEvent_Types_V1Args = {
  distinct_on?: InputMaybe<Array<Event_Types_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_V1_Order_By>>;
  where?: InputMaybe<Event_Types_V1_Bool_Exp>;
};


export type Query_RootEvent_Types_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_V1_Order_By>>;
  where?: InputMaybe<Event_Types_V1_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
};


export type Query_RootProjects_By_Collection_V1Args = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_V1_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
};


export type Query_RootProjects_By_Collection_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_V1_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
};


export type Query_RootProjects_V1Args = {
  distinct_on?: InputMaybe<Array<Projects_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_V1_Order_By>>;
  where?: InputMaybe<Projects_V1_Bool_Exp>;
};


export type Query_RootProjects_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_V1_Order_By>>;
  where?: InputMaybe<Projects_V1_Bool_Exp>;
};


export type Query_RootUsers_V1Args = {
  distinct_on?: InputMaybe<Array<Users_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_V1_Order_By>>;
  where?: InputMaybe<Users_V1_Bool_Exp>;
};


export type Query_RootUsers_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_V1_Order_By>>;
  where?: InputMaybe<Users_V1_Bool_Exp>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "artifacts_by_project_v1" */
  artifacts_by_project_v1: Array<Artifacts_By_Project_V1>;
  /** fetch aggregated fields from the table: "artifacts_by_project_v1" */
  artifacts_by_project_v1_aggregate: Artifacts_By_Project_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "artifacts_by_project_v1" */
  artifacts_by_project_v1_stream: Array<Artifacts_By_Project_V1>;
  /** fetch data from the table: "artifacts_v1" */
  artifacts_v1: Array<Artifacts_V1>;
  /** fetch aggregated fields from the table: "artifacts_v1" */
  artifacts_v1_aggregate: Artifacts_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "artifacts_v1" */
  artifacts_v1_stream: Array<Artifacts_V1>;
  /** fetch data from the table: "code_metrics_by_project_v1" */
  code_metrics_by_project_v1: Array<Code_Metrics_By_Project_V1>;
  /** fetch aggregated fields from the table: "code_metrics_by_project_v1" */
  code_metrics_by_project_v1_aggregate: Code_Metrics_By_Project_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "code_metrics_by_project_v1" */
  code_metrics_by_project_v1_stream: Array<Code_Metrics_By_Project_V1>;
  /** fetch data from the table: "collections_v1" */
  collections_v1: Array<Collections_V1>;
  /** fetch aggregated fields from the table: "collections_v1" */
  collections_v1_aggregate: Collections_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "collections_v1" */
  collections_v1_stream: Array<Collections_V1>;
  /** fetch data from the table: "contracts_v0" */
  contracts_v0: Array<Contracts_V0>;
  /** fetch aggregated fields from the table: "contracts_v0" */
  contracts_v0_aggregate: Contracts_V0_Aggregate;
  /** fetch data from the table in a streaming manner: "contracts_v0" */
  contracts_v0_stream: Array<Contracts_V0>;
  /** fetch data from the table: "event_indexing_status_by_project_v1" */
  event_indexing_status_by_project_v1: Array<Event_Indexing_Status_By_Project_V1>;
  /** fetch aggregated fields from the table: "event_indexing_status_by_project_v1" */
  event_indexing_status_by_project_v1_aggregate: Event_Indexing_Status_By_Project_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "event_indexing_status_by_project_v1" */
  event_indexing_status_by_project_v1_stream: Array<Event_Indexing_Status_By_Project_V1>;
  /** fetch data from the table: "event_types_v1" */
  event_types_v1: Array<Event_Types_V1>;
  /** fetch aggregated fields from the table: "event_types_v1" */
  event_types_v1_aggregate: Event_Types_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "event_types_v1" */
  event_types_v1_stream: Array<Event_Types_V1>;
  /** fetch data from the table: "events_daily_to_artifact" */
  events_daily_to_artifact: Array<Events_Daily_To_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_to_artifact" */
  events_daily_to_artifact_aggregate: Events_Daily_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_artifact" */
  events_daily_to_artifact_stream: Array<Events_Daily_To_Artifact>;
  /** fetch data from the table: "events_daily_to_collection" */
  events_daily_to_collection: Array<Events_Daily_To_Collection>;
  /** fetch aggregated fields from the table: "events_daily_to_collection" */
  events_daily_to_collection_aggregate: Events_Daily_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_collection" */
  events_daily_to_collection_stream: Array<Events_Daily_To_Collection>;
  /** fetch data from the table: "events_daily_to_project" */
  events_daily_to_project: Array<Events_Daily_To_Project>;
  /** fetch aggregated fields from the table: "events_daily_to_project" */
  events_daily_to_project_aggregate: Events_Daily_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_project" */
  events_daily_to_project_stream: Array<Events_Daily_To_Project>;
  /** fetch data from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact: Array<Events_Monthly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact_aggregate: Events_Monthly_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_artifact" */
  events_monthly_to_artifact_stream: Array<Events_Monthly_To_Artifact>;
  /** fetch data from the table: "events_monthly_to_collection" */
  events_monthly_to_collection: Array<Events_Monthly_To_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_to_collection" */
  events_monthly_to_collection_aggregate: Events_Monthly_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_collection" */
  events_monthly_to_collection_stream: Array<Events_Monthly_To_Collection>;
  /** fetch data from the table: "events_monthly_to_project" */
  events_monthly_to_project: Array<Events_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "events_monthly_to_project" */
  events_monthly_to_project_aggregate: Events_Monthly_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_project" */
  events_monthly_to_project_stream: Array<Events_Monthly_To_Project>;
  /** fetch data from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact: Array<Events_Weekly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact_aggregate: Events_Weekly_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_artifact" */
  events_weekly_to_artifact_stream: Array<Events_Weekly_To_Artifact>;
  /** fetch data from the table: "events_weekly_to_collection" */
  events_weekly_to_collection: Array<Events_Weekly_To_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_to_collection" */
  events_weekly_to_collection_aggregate: Events_Weekly_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_collection" */
  events_weekly_to_collection_stream: Array<Events_Weekly_To_Collection>;
  /** fetch data from the table: "events_weekly_to_project" */
  events_weekly_to_project: Array<Events_Weekly_To_Project>;
  /** fetch aggregated fields from the table: "events_weekly_to_project" */
  events_weekly_to_project_aggregate: Events_Weekly_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_project" */
  events_weekly_to_project_stream: Array<Events_Weekly_To_Project>;
  /** fetch data from the table: "onchain_metrics_by_project_v1" */
  onchain_metrics_by_project_v1: Array<Onchain_Metrics_By_Project_V1>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_project_v1" */
  onchain_metrics_by_project_v1_aggregate: Onchain_Metrics_By_Project_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "onchain_metrics_by_project_v1" */
  onchain_metrics_by_project_v1_stream: Array<Onchain_Metrics_By_Project_V1>;
  /** fetch data from the table: "projects_by_collection_v1" */
  projects_by_collection_v1: Array<Projects_By_Collection_V1>;
  /** fetch aggregated fields from the table: "projects_by_collection_v1" */
  projects_by_collection_v1_aggregate: Projects_By_Collection_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "projects_by_collection_v1" */
  projects_by_collection_v1_stream: Array<Projects_By_Collection_V1>;
  /** fetch data from the table: "projects_v1" */
  projects_v1: Array<Projects_V1>;
  /** fetch aggregated fields from the table: "projects_v1" */
  projects_v1_aggregate: Projects_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "projects_v1" */
  projects_v1_stream: Array<Projects_V1>;
  /** fetch data from the table: "users_v1" */
  users_v1: Array<Users_V1>;
  /** fetch aggregated fields from the table: "users_v1" */
  users_v1_aggregate: Users_V1_Aggregate;
  /** fetch data from the table in a streaming manner: "users_v1" */
  users_v1_stream: Array<Users_V1>;
};


export type Subscription_RootArtifacts_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_V1_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootArtifacts_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_V1_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootArtifacts_By_Project_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Artifacts_By_Project_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Artifacts_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootArtifacts_V1Args = {
  distinct_on?: InputMaybe<Array<Artifacts_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_V1_Order_By>>;
  where?: InputMaybe<Artifacts_V1_Bool_Exp>;
};


export type Subscription_RootArtifacts_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_V1_Order_By>>;
  where?: InputMaybe<Artifacts_V1_Bool_Exp>;
};


export type Subscription_RootArtifacts_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Artifacts_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Artifacts_V1_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Project_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Code_Metrics_By_Project_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Code_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootCollections_V1Args = {
  distinct_on?: InputMaybe<Array<Collections_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_V1_Order_By>>;
  where?: InputMaybe<Collections_V1_Bool_Exp>;
};


export type Subscription_RootCollections_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_V1_Order_By>>;
  where?: InputMaybe<Collections_V1_Bool_Exp>;
};


export type Subscription_RootCollections_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_V1_Bool_Exp>;
};


export type Subscription_RootContracts_V0Args = {
  distinct_on?: InputMaybe<Array<Contracts_V0_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_V0_Order_By>>;
  where?: InputMaybe<Contracts_V0_Bool_Exp>;
};


export type Subscription_RootContracts_V0_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_V0_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contracts_V0_Order_By>>;
  where?: InputMaybe<Contracts_V0_Bool_Exp>;
};


export type Subscription_RootContracts_V0_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contracts_V0_Stream_Cursor_Input>>;
  where?: InputMaybe<Contracts_V0_Bool_Exp>;
};


export type Subscription_RootEvent_Indexing_Status_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Order_By>>;
  where?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootEvent_Indexing_Status_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Indexing_Status_By_Project_V1_Order_By>>;
  where?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootEvent_Indexing_Status_By_Project_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Indexing_Status_By_Project_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Indexing_Status_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootEvent_Types_V1Args = {
  distinct_on?: InputMaybe<Array<Event_Types_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_V1_Order_By>>;
  where?: InputMaybe<Event_Types_V1_Bool_Exp>;
};


export type Subscription_RootEvent_Types_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_V1_Order_By>>;
  where?: InputMaybe<Event_Types_V1_Bool_Exp>;
};


export type Subscription_RootEvent_Types_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Types_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Types_V1_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Project_V1Args = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Project_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_V1_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Project_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Onchain_Metrics_By_Project_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_V1_Bool_Exp>;
};


export type Subscription_RootProjects_By_Collection_V1Args = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_V1_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
};


export type Subscription_RootProjects_By_Collection_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_V1_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
};


export type Subscription_RootProjects_By_Collection_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_By_Collection_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_By_Collection_V1_Bool_Exp>;
};


export type Subscription_RootProjects_V1Args = {
  distinct_on?: InputMaybe<Array<Projects_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_V1_Order_By>>;
  where?: InputMaybe<Projects_V1_Bool_Exp>;
};


export type Subscription_RootProjects_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_V1_Order_By>>;
  where?: InputMaybe<Projects_V1_Bool_Exp>;
};


export type Subscription_RootProjects_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_V1_Bool_Exp>;
};


export type Subscription_RootUsers_V1Args = {
  distinct_on?: InputMaybe<Array<Users_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_V1_Order_By>>;
  where?: InputMaybe<Users_V1_Bool_Exp>;
};


export type Subscription_RootUsers_V1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_V1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_V1_Order_By>>;
  where?: InputMaybe<Users_V1_Bool_Exp>;
};


export type Subscription_RootUsers_V1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_V1_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_V1_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "users_v1" */
export type Users_V1 = {
  __typename?: 'users_v1';
  bio?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  profile_picture_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_source?: Maybe<Scalars['String']['output']>;
  user_source_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "users_v1" */
export type Users_V1_Aggregate = {
  __typename?: 'users_v1_aggregate';
  aggregate?: Maybe<Users_V1_Aggregate_Fields>;
  nodes: Array<Users_V1>;
};

/** aggregate fields of "users_v1" */
export type Users_V1_Aggregate_Fields = {
  __typename?: 'users_v1_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_V1_Max_Fields>;
  min?: Maybe<Users_V1_Min_Fields>;
};


/** aggregate fields of "users_v1" */
export type Users_V1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_V1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users_v1". All fields are combined with a logical 'AND'. */
export type Users_V1_Bool_Exp = {
  _and?: InputMaybe<Array<Users_V1_Bool_Exp>>;
  _not?: InputMaybe<Users_V1_Bool_Exp>;
  _or?: InputMaybe<Array<Users_V1_Bool_Exp>>;
  bio?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  profile_picture_url?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_source?: InputMaybe<String_Comparison_Exp>;
  user_source_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Users_V1_Max_Fields = {
  __typename?: 'users_v1_max_fields';
  bio?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  profile_picture_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_source?: Maybe<Scalars['String']['output']>;
  user_source_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_V1_Min_Fields = {
  __typename?: 'users_v1_min_fields';
  bio?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  profile_picture_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_source?: Maybe<Scalars['String']['output']>;
  user_source_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "users_v1". */
export type Users_V1_Order_By = {
  bio?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  profile_picture_url?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_source?: InputMaybe<Order_By>;
  user_source_id?: InputMaybe<Order_By>;
};

/** select columns of table "users_v1" */
export enum Users_V1_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  ProfilePictureUrl = 'profile_picture_url',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserSource = 'user_source',
  /** column name */
  UserSourceId = 'user_source_id'
}

/** Streaming cursor of the table "users_v1" */
export type Users_V1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_V1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_V1_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  profile_picture_url?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_source?: InputMaybe<Scalars['String']['input']>;
  user_source_id?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtifactsQuery = { __typename?: 'query_root', artifacts_v1: Array<{ __typename?: 'artifacts_v1', artifact_id?: string | null, artifact_source?: string | null, artifact_namespace?: string | null, artifact_name?: string | null, artifact_url?: string | null }> };

export type ArtifactByIdsQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ArtifactByIdsQuery = { __typename?: 'query_root', artifacts_v1: Array<{ __typename?: 'artifacts_v1', artifact_id?: string | null, artifact_source?: string | null, artifact_namespace?: string | null, artifact_name?: string | null, artifact_url?: string | null }> };

export type ArtifactBySourceNamespaceNameQueryVariables = Exact<{
  artifact_source: Scalars['String']['input'];
  artifact_namespace: Scalars['String']['input'];
  artifact_name: Scalars['String']['input'];
}>;


export type ArtifactBySourceNamespaceNameQuery = { __typename?: 'query_root', artifacts_v1: Array<{ __typename?: 'artifacts_v1', artifact_id?: string | null, artifact_source?: string | null, artifact_namespace?: string | null, artifact_name?: string | null, artifact_url?: string | null }> };

export type ArtifactBySourceNameQueryVariables = Exact<{
  artifact_source: Scalars['String']['input'];
  artifact_name: Scalars['String']['input'];
}>;


export type ArtifactBySourceNameQuery = { __typename?: 'query_root', artifacts_v1: Array<{ __typename?: 'artifacts_v1', artifact_id?: string | null, artifact_source?: string | null, artifact_namespace?: string | null, artifact_name?: string | null, artifact_url?: string | null }> };

export type ArtifactIdsByProjectIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ArtifactIdsByProjectIdsQuery = { __typename?: 'query_root', artifacts_by_project_v1: Array<{ __typename?: 'artifacts_by_project_v1', artifact_id?: string | null }> };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'query_root', projects_v1: Array<{ __typename?: 'projects_v1', project_id?: string | null, project_source?: string | null, project_namespace?: string | null, project_name?: string | null, display_name?: string | null }> };

export type ProjectsByIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProjectsByIdsQuery = { __typename?: 'query_root', projects_v1: Array<{ __typename?: 'projects_v1', project_id?: string | null, project_source?: string | null, project_namespace?: string | null, project_name?: string | null, display_name?: string | null, description?: string | null }> };

export type ProjectByNameQueryVariables = Exact<{
  project_name: Scalars['String']['input'];
}>;


export type ProjectByNameQuery = { __typename?: 'query_root', projects_v1: Array<{ __typename?: 'projects_v1', project_id?: string | null, project_source?: string | null, project_namespace?: string | null, project_name?: string | null, display_name?: string | null, description?: string | null }> };

export type CollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsQuery = { __typename?: 'query_root', collections_v1: Array<{ __typename?: 'collections_v1', collection_id?: string | null, collection_source?: string | null, collection_namespace?: string | null, collection_name?: string | null, display_name?: string | null }> };

export type CollectionsByIdsQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CollectionsByIdsQuery = { __typename?: 'query_root', collections_v1: Array<{ __typename?: 'collections_v1', collection_id?: string | null, collection_source?: string | null, collection_namespace?: string | null, collection_name?: string | null, display_name?: string | null, description?: string | null }> };

export type CollectionByNameQueryVariables = Exact<{
  collection_name: Scalars['String']['input'];
}>;


export type CollectionByNameQuery = { __typename?: 'query_root', collections_v1: Array<{ __typename?: 'collections_v1', collection_id?: string | null, collection_source?: string | null, collection_namespace?: string | null, collection_name?: string | null, display_name?: string | null, description?: string | null }> };

export type CollectionIdsByProjectIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CollectionIdsByProjectIdsQuery = { __typename?: 'query_root', projects_by_collection_v1: Array<{ __typename?: 'projects_by_collection_v1', collection_id?: string | null }> };

export type CodeMetricsByProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CodeMetricsByProjectQuery = { __typename?: 'query_root', code_metrics_by_project_v1: Array<{ __typename?: 'code_metrics_by_project_v1', project_id?: string | null, project_source?: string | null, project_namespace?: string | null, project_name?: string | null, display_name?: string | null, event_source?: string | null, active_developer_count_6_months?: any | null, closed_issue_count_6_months?: any | null, commit_count_6_months?: any | null, contributor_count?: any | null, contributor_count_6_months?: any | null, first_commit_date?: any | null, fork_count?: any | null, fulltime_developer_average_6_months?: any | null, last_commit_date?: any | null, merged_pull_request_count_6_months?: any | null, new_contributor_count_6_months?: any | null, opened_issue_count_6_months?: any | null, opened_pull_request_count_6_months?: any | null, repository_count?: any | null, star_count?: any | null }> };

export type OnchainMetricsByProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OnchainMetricsByProjectQuery = { __typename?: 'query_root', onchain_metrics_by_project_v1: Array<{ __typename?: 'onchain_metrics_by_project_v1', project_id?: string | null, project_source?: string | null, project_namespace?: string | null, project_name?: string | null, display_name?: string | null, event_source?: string | null, active_contract_count_90_days?: any | null, address_count?: any | null, address_count_90_days?: any | null, days_since_first_transaction?: any | null, gas_fees_sum?: any | null, gas_fees_sum_6_months?: any | null, high_activity_address_count_90_days?: any | null, low_activity_address_count_90_days?: any | null, medium_activity_address_count_90_days?: any | null, multi_project_address_count_90_days?: any | null, new_address_count_90_days?: any | null, returning_address_count_90_days?: any | null, transaction_count?: any | null, transaction_count_6_months?: any | null }> };

export type GetAllEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEventTypesQuery = { __typename?: 'query_root', event_types_v1: Array<{ __typename?: 'event_types_v1', event_type?: string | null }> };

export type EventsDailyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToCollectionQuery = { __typename?: 'query_root', events_daily_to_collection: Array<{ __typename?: 'events_daily_to_collection', collection_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToCollectionQuery = { __typename?: 'query_root', events_weekly_to_collection: Array<{ __typename?: 'events_weekly_to_collection', collection_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToCollectionQuery = { __typename?: 'query_root', events_monthly_to_collection: Array<{ __typename?: 'events_monthly_to_collection', collection_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };

export type EventsDailyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToProjectQuery = { __typename?: 'query_root', events_daily_to_project: Array<{ __typename?: 'events_daily_to_project', project_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToProjectQuery = { __typename?: 'query_root', events_weekly_to_project: Array<{ __typename?: 'events_weekly_to_project', project_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToProjectQuery = { __typename?: 'query_root', events_monthly_to_project: Array<{ __typename?: 'events_monthly_to_project', project_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };

export type EventsDailyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToArtifactQuery = { __typename?: 'query_root', events_daily_to_artifact: Array<{ __typename?: 'events_daily_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToArtifactQuery = { __typename?: 'query_root', events_weekly_to_artifact: Array<{ __typename?: 'events_weekly_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToArtifactQuery = { __typename?: 'query_root', events_monthly_to_artifact: Array<{ __typename?: 'events_monthly_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };


export const ArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Artifacts"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_v1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactsQuery, ArtifactsQueryVariables>;
export const ArtifactByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactByIdsQuery, ArtifactByIdsQueryVariables>;
export const ArtifactBySourceNamespaceNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactBySourceNamespaceName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_source"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactBySourceNamespaceNameQuery, ArtifactBySourceNamespaceNameQueryVariables>;
export const ArtifactBySourceNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactBySourceName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_source"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactBySourceNameQuery, ArtifactBySourceNameQueryVariables>;
export const ArtifactIdsByProjectIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactIdsByProjectIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_by_project_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}}]}}]}}]} as unknown as DocumentNode<ArtifactIdsByProjectIdsQuery, ArtifactIdsByProjectIdsQueryVariables>;
export const ProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Projects"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_v1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_source"}},{"kind":"Field","name":{"kind":"Name","value":"project_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_source"}},{"kind":"Field","name":{"kind":"Name","value":"project_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>;
export const ProjectByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_source"}},{"kind":"Field","name":{"kind":"Name","value":"project_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProjectByNameQuery, ProjectByNameQueryVariables>;
export const CollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Collections"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections_v1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"collection_source"}},{"kind":"Field","name":{"kind":"Name","value":"collection_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<CollectionsQuery, CollectionsQueryVariables>;
export const CollectionsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"collection_source"}},{"kind":"Field","name":{"kind":"Name","value":"collection_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CollectionsByIdsQuery, CollectionsByIdsQueryVariables>;
export const CollectionByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"collection_source"}},{"kind":"Field","name":{"kind":"Name","value":"collection_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CollectionByNameQuery, CollectionByNameQueryVariables>;
export const CollectionIdsByProjectIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionIdsByProjectIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_collection_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}}]}}]}}]} as unknown as DocumentNode<CollectionIdsByProjectIdsQuery, CollectionIdsByProjectIdsQueryVariables>;
export const CodeMetricsByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CodeMetricsByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code_metrics_by_project_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_source"}},{"kind":"Field","name":{"kind":"Name","value":"project_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"event_source"}},{"kind":"Field","name":{"kind":"Name","value":"active_developer_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"closed_issue_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"commit_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"contributor_count"}},{"kind":"Field","name":{"kind":"Name","value":"contributor_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"first_commit_date"}},{"kind":"Field","name":{"kind":"Name","value":"fork_count"}},{"kind":"Field","name":{"kind":"Name","value":"fulltime_developer_average_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"last_commit_date"}},{"kind":"Field","name":{"kind":"Name","value":"merged_pull_request_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"new_contributor_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"opened_issue_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"opened_pull_request_count_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"repository_count"}},{"kind":"Field","name":{"kind":"Name","value":"star_count"}}]}}]}}]} as unknown as DocumentNode<CodeMetricsByProjectQuery, CodeMetricsByProjectQueryVariables>;
export const OnchainMetricsByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnchainMetricsByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onchain_metrics_by_project_v1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_source"}},{"kind":"Field","name":{"kind":"Name","value":"project_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"event_source"}},{"kind":"Field","name":{"kind":"Name","value":"active_contract_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"address_count"}},{"kind":"Field","name":{"kind":"Name","value":"address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"days_since_first_transaction"}},{"kind":"Field","name":{"kind":"Name","value":"gas_fees_sum"}},{"kind":"Field","name":{"kind":"Name","value":"gas_fees_sum_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"high_activity_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"low_activity_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"medium_activity_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"multi_project_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"new_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"returning_address_count_90_days"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_count"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_count_6_months"}}]}}]}}]} as unknown as DocumentNode<OnchainMetricsByProjectQuery, OnchainMetricsByProjectQueryVariables>;
export const GetAllEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllEventTypes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_types_v1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}}]}}]}}]} as unknown as DocumentNode<GetAllEventTypesQuery, GetAllEventTypesQueryVariables>;
export const EventsDailyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToCollectionQuery, EventsDailyToCollectionQueryVariables>;
export const EventsWeeklyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToCollectionQuery, EventsWeeklyToCollectionQueryVariables>;
export const EventsMonthlyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToCollectionQuery, EventsMonthlyToCollectionQueryVariables>;
export const EventsDailyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToProjectQuery, EventsDailyToProjectQueryVariables>;
export const EventsWeeklyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToProjectQuery, EventsWeeklyToProjectQueryVariables>;
export const EventsMonthlyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToProjectQuery, EventsMonthlyToProjectQueryVariables>;
export const EventsDailyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToArtifactQuery, EventsDailyToArtifactQueryVariables>;
export const EventsWeeklyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToArtifactQuery, EventsWeeklyToArtifactQueryVariables>;
export const EventsMonthlyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToArtifactQuery, EventsMonthlyToArtifactQueryVariables>;